module.exports = __webpack_public_path__ + "static/media/Location_Book-Page39.8f3519e6.png";